import { BasicDialogProperties } from "../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2SendGiftDialogProperties extends BasicDialogProperties {
    public seatId: number = 0;

    constructor(seatId: number) {
        super();

        this.seatId = seatId;
    }
}
